<template>
  <div class="home">
    <h1>Dashboard</h1>
    <div id="inv_button"></div>
  </div>
</template>

<script>

  export default {
    name: 'Home',
    components: {
    }
  }
</script>